<template>
    <div>
        <div ref="icon" class="feather-icon" @click="$emit('click')" />
    </div>
</template>

<script>
import * as feather from 'feather-icons'

export default {
    name: 'FeatherIcon',
    props: {
        name: {
            type: String,
            default: 'circle',
            note: 'these are the icons names that can be found on feathericons.com or in the figma file',
            required: true,
        },
    },
    watch: {
        name: function () {
            this.reload()
        },
        color: function () {
            this.reload()
        },
    },
    mounted() {
        this.reload()
    },
    methods: {
        reload() {
            let icon = this.$refs['icon']
            const featherIcon = feather.icons[this.name]
            if (featherIcon) {
                icon.innerHTML = featherIcon.toSvg()
            }
        },
    },
}
</script>
<style lang="sass">
.feather-icon
    display: flex
    justify-content: center
    align-items: center
    width: 2.4rem
    height: 2.4rem
    color: $neutral-3

    svg
        width: 100%
        height: 100%
        stroke-width: 2px
        stroke: currentColor
</style>
